// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__7AkRI","notes":"Notes_notes__290A7"};